// Module
var code = "<react-code-editor\n  id=\"$ctrl.identifier\"\n  text-tip=\"$ctrl.textTip\"\n  type=\"$ctrl.type\"\n  readonly=\"$ctrl.readOnly\"\n  on-change=\"($ctrl.handleChange)\"\n  value=\"$ctrl.value\"\n  height=\"$ctrl.height || undefined\"\n  versions=\"$ctrl.versions\"\n  on-version-change=\"($ctrl.onVersionChange)\"\n  schema=\"$ctrl.schema\"\n></react-code-editor>\n";
// Exports
var _module_exports = code;;
var path = 'app/portainer/components/code-editor/code-editor.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;